import { Button } from "@ths/ui";
import { useState } from "react";

import ConfirmationStep from "../components/RequestForm/ConfirmationStep";
import DetailsStep from "../components/RequestForm/DetailsStep";

type Step = "details" | "confirm";

interface Props {
  sessionToken?: string;
  assignmentId?: string;
  basecamp?: { id: string; name: string };
  room?: {
    basecampRoomId: string;
    buildingName: string;
    roomNumber: string;
  };
  contact: {
    phone: string;
    email: string;
  };
  onClose: () => void;
}

export default function RequestFormPage({
  sessionToken,
  assignmentId,
  basecamp,
  room,
  contact,
  onClose,
}: Props) {
  const [step, setStep] = useState<Step>("details");

  return (
    <main className="relative z-10 flex flex-1 flex-col items-center bg-surface px-6 py-10 text-text">
      {step === "details" ? (
        <DetailsStep
          room={room}
          basecamp={basecamp}
          prefilledContact={contact}
          sessionToken={sessionToken}
          assignmentId={assignmentId}
          onSubmitted={() => setStep("confirm")}
        />
      ) : (
        <ConfirmationStep onDone={onClose} />
      )}
      {step !== "confirm" && !sessionToken && (
        <Button
          type="button"
          onClick={onClose}
          variant="ghost"
          className="mt-6 w-full max-w-md"
        >
          Cancel
        </Button>
      )}
    </main>
  );
}
